import { TAO_KOE, EN_KO } from './../libs';
import Video from './video.js';

// Class to handle the popup.
class VideoPopup {
	constructor( popupEl ) {
		this.popupEl = popupEl;

		// Remove iframe on popupclose.
		document.addEventListener( 'popup_closed.sl', ( evt ) => {
			if ( evt.target.matches( '.tao_video_popup' ) ) {
				this.onClose();
			}
		} );
	}

	onClose() {
		const iFrameEls = this.popupEl.querySelectorAll( 'iframe' );
		iFrameEls.forEach( ( iFrameEl ) => iFrameEl.remove() );
		return true;
	}

	addIframe( src ) {
		const iFrameEl = document.createElement( 'iframe' );
		iFrameEl.src = src;
		iFrameEl.frameBorder = '0';
		iFrameEl.style = 'width:100%;height:100%;';

		if ( Video.is_youtube( src ) ) {
			iFrameEl.allowFullscreen = true;
		}

		// Add iFrame to container.
		const containerEl = this.popupEl.querySelector( '.tao_video_container' );
		containerEl.innerHTML = '';
		containerEl.appendChild( iFrameEl );
	}

	setTitle( title ) {
		// Get title Elements.
		const contentEl = this.popupEl.querySelector( '.mdl_popup__content' );
		const headerEl = contentEl.querySelector( '.mdl_popup__header' );

		// Set Popup Title HTML.
		const hasTitle = !! title;
		headerEl.innerHTML = `<span class="tao_popup_title">${ title }</span>`;
		headerEl.classList.toggle( 'en_hidden', ! hasTitle );
		contentEl.classList.toggle( 'mdl_popup__content--with-heading', hasTitle );
	}

	openVideo( href, title ) {
		const src = Video.extract_video_url( href );

		if ( src && ( Video.is_youtube( href ) || Video.is_vimeo( href ) ) ) {
			// Set Popup Content
			this.addIframe( src );
			this.setTitle( title );

			// Open Popup.
			EN_KO.functions.open_popup( this.popupEl );

			return true;
		}

		return false;
	}

	close() {
		EN_KO.functions.close_popup( this.popupEl );
	}

	static getInstance() {
		const popupEl = document.getElementById( 'popup_tao_video' );
		if ( ! popupEl ) {
			return null;
		}

		// Create new Instance, if not available.
		popupEl.TAO_Video_Popup ??= new VideoPopup( popupEl );
		return popupEl.TAO_Video_Popup;
	}
}

const initVideoPopup = function() {
	// Initialise Popup.
	const VideoPopupInstance = VideoPopup.getInstance();
	if ( VideoPopupInstance ) {
		// Add Mutation Observer to listen to quickview close.
		document.addEventListener( 'click', ( evt ) => {
			const linkEl = evt.target.closest( 'a' );
			if ( linkEl && linkEl.matches( '[target=_lightbox]' ) ) {
				const href = linkEl.href;
				const title = linkEl.getAttribute( 'title' ) || linkEl.getAttribute( 'aria-label' );

				// Open popup.
				const success = VideoPopupInstance.openVideo( href, title );

				if ( success ) {
					evt.preventDefault();
				} else {
					linkEl.setAttribute( 'target', '_blank' );
				}
			}
		} );
	}
};

// Init.
TAO_KOE.ready( 'video-popup.js', initVideoPopup );

// Export
export {
	VideoPopup as default,
	initVideoPopup,
};
